import React from 'react';

interface Props {
    top: JSX.Element;
    side: JSX.Element;
    bottom: JSX.Element;
}

const ContentSideFeature: React.FunctionComponent<Props> = ({ top, side, bottom }) => (
    <div className="content-side-feature">
        <div className="content-side-feature__top">
            <div className="content-side-feature__top__content">{top}</div>
        </div>
        <div className="content-side-feature__side">
            <div className="content-side-feature__side__content">{side}</div>
        </div>
        <div className="content-side-feature__bottom">
            <div className="content-side-feature__bottom__content">{bottom}</div>
        </div>
    </div>
);

export default ContentSideFeature;
